// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".camera-card{border-radius:.5em;overflow:hidden;transition:box-shadow .1s ease-out,transform .1s ease-out}.camera-card:not(.snapshot-card--highlighted){box-shadow:1px 2px 10px -2px #000}.camera-card.camera-card--hoverable:hover:not(.list-transition-move):not(.snapshot-card--highlighted){box-shadow:0 8px 12px -5px rgba(0,0,0,.85);transform:scale(1.025)}.camera-card__label{font-size:small;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
